import { z } from "zod";

import { FIELD_TYPE, FILTER_TYPE } from "@/features/forms/models";
import { productSchema } from "@/features/products/models";

const healthieFieldSchema = z.object({
  id: z.string(),
  label: z.string(),
  required: z.boolean(),
  options: z.array(z.string()),
  type: z.enum(FIELD_TYPE),
  customModuleCondition: z
    .object({
      filterType: z.enum(FILTER_TYPE),
      valueToFilter: z.string(),
      conditionalCustomModuleId: z.string(),
      customModuleId: z.string(),
    })
    .nullable(),
  value: z.string().nullable(),
});

export const healthieFormParamsSchema = z.object({
  productId: productSchema.shape.id.nullable(),
  isAsync: z.boolean(),
  isRefill: z.boolean(),
  withRefill: z.boolean(),
});

export const healthieFormSchema = z.object({
  formId: z.string(),
  fields: z.array(healthieFieldSchema),
});
